module.exports = __webpack_public_path__ + "img/mao.0ab5c86c.png";